export default __webpack_public_path__ + "static/media/OpenSans-Bold.b45ea200.eot";